import {
    get,
    post,
    formDataPost,
    postWithQuery,
    Delete,
} from "../ApiDecorator";

/**
 * 组卷任务（/course/spx/examCompose）
 * 文档未提供：细目表模板下载
 */
const ExamCompose = {
    /** GET 当前项目组卷任务列表 */
    getList(data) {
        return get("/course/spx/examCompose/list", data);
    },
    /** GET 按学段、学科筛可选子空间 */
    getSpaces(data) {
        return get("/course/spx/examCompose/spaces", data);
    },
    /** POST 新建或修改未发布任务 */
    save(data) {
        return post("/course/spx/examCompose/save", data);
    },
    /** GET 任务详情 */
    getDetail(data) {
        return get("/course/spx/examCompose/detail", data);
    },
    /** POST 导入细目表，只解析不入库 */
    importSpec(data) {
        return formDataPost("/course/spx/examCompose/importSpec", data);
    },
    /** POST 发布任务，query: id */
    publish(data) {
        return postWithQuery("/course/spx/examCompose/publish", {}, data);
    },
    /** DELETE 逻辑删除任务，query: id */
    delete(data) {
        return Delete("/course/spx/examCompose", data);
    },
};

export default ExamCompose;
